import global from '../assets/js/global_variable.js';

export default {
  // 获取cookie
  getCookie: function (name) {
    var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
    if (arr = document.cookie.match(reg)) {
      return (arr[2]);
    } else {
      return null;
    }
  },

   deepCopy(obj){
    let _obj = JSON.stringify(obj)
    let newObj = JSON.parse(_obj)
    return newObj;
  },

  // 设置cookie,增加到vue实例方便全局调用
  setCookie: function (c_name, value, expiredays) {
    var exdate = new Date();
    exdate.setDate(exdate.getDate() + expiredays);
    document.cookie = c_name + "=" + escape(value) + ((expiredays == null) ? "" : ";expires=" + exdate.toGMTString()) + ';domain=.cect360.com';
  },

  // 删除cookie
  delCookie: function (name) {
    var exp = new Date();
    exp.setTime(exp.getTime() - 1);
    var cval = this.getCookie(name);
    console
    if (cval != null) {
      document.cookie = name + "=" + cval + ";expires=" + exp.toGMTString() + ';domain=.cect360.com';
    }
  },

  // 获取当前地址栏相对路径
  getUrlRelativePath: function () {
    var url = document.location.toString();
    var arrUrl = url.split("//");

    var start = arrUrl[1].indexOf("/");
    var relUrl = arrUrl[1].substring(start);//stop省略，截取从start开始到结尾的所有字符

    if (relUrl.indexOf("?") != -1) {
      relUrl = relUrl.split("?")[0];
    }
    return relUrl;
  },

  // DK → position
  positionDataChange: function (changeData, basicStandard, ratio) {
    // changeData： 需换换数据, basicStandard 基准值, ratio DK转换比率
    return ((Number(changeData) - basicStandard)) * ratio
  },

  // 整数分解为字符串数组
  intDecomposingNumbers: function (Num) {
    return [...(Num + '')].map(Number)
  },

  // 小数拆解为整数和小数两部分
  decimalDecomposingNumbers: function (Num) {
    return Num.toString().split('.')
  },

  // 删除数组指定元素
  arrayRemove: function (array, element) {
    return array.splice(
      array.findIndex((item) => item === element),
      1
    )
  },

  // 字符串日期格式化
  strDateFormat: function (strDate, dateType) {
    if (strDate) {
      if (typeof strDate != 'string') {
        strDate = strDate + ''
      }

      if (dateType == 'yyyy-MM-dd hh:mm') {
        return strDate.slice(0, -3)
      } else if (dateType == 'yyyy-MM-dd hh') {
        return strDate.slice(0, -6)
      } else if (dateType == 'yyyy-MM-dd') {
        return strDate.slice(0, -9)
      } else if (dateType == 'yyyy-MM') {
        return strDate.slice(0, -12)
      } else if (dateType == 'yyyy') {
        return strDate.slice(0, -15)
      }
    }
  },

}



// WEBPACK FOOTER //
// ./src/utils/tools.js